import { defineStore } from 'pinia'
import axios from "axios";
import ApiHelper from "@/helpsers/api.helper";
import authHelper from "@/helpsers/auth.helper";

export const useClientsStore = defineStore({
    id: 'clients',
    state: () => {
        return {
            clients: [],
            page: 1,
            onPage: 1000,
            total: 0,
            isLoading: false,
            selectedSortType: null,
            selectedFilterType: null,
            sortTypes: [],
            filterTypes: [
                "ACTIVE_PROJECT",
                "FINISHED_PROJECT",
            ]
        }
    },
    actions: {
        async fetchClients() {
            this.isLoading = true;
            let requestParams = {
                onPage: this.onPage,
                pageNumber: this.page,
            }
            if (this.selectedSortType)
                requestParams.order = this.selectedSortType;
            if (this.selectedFilterType)
                requestParams.filter = this.selectedFilterType;
            axios.get(ApiHelper.getClientsUrl(), {
                headers: authHelper.authHeader(),
                params: requestParams
            }).then(result => {
                let data = result.data;
                this.total = data.total ?? 0;
                this.onPage = data.onPage ?? 25;
                this.page = data.pageNumber ?? 1;
                this.clients = data.data ?? [];
                this.isLoading = false;
            }).catch(errorResponse => {
                this.isLoading = false;
            });
        },
        async fetchSortTypes() {
            axios.get(ApiHelper.getClientsSortTypesUrl(), {
                headers: authHelper.authHeader(),
            }).then(result => {
                this.sortTypes = result.data ?? [];
            }).catch(errorResponse => {
            })
        },

        fetchAllClients() {
            axios.get(ApiHelper.getClientsUrl(), {
                headers: authHelper.authHeader(),
            }).then(result => {
                let data = result.data;
                this.clients = data.data ?? [];
                this.isLoading = false;
            }).catch(errorResponse => {
                this.isLoading = false;
            });
        }
    },
});
